//src/rtkQuery/config/testimonialApi.config.ts

export const TESTIMONIAL_ENDPOINTS = {
  GET_ALL: '/testimonials/testimonials',
  SUBMIT: '/testimonials/testimonial',
} as const;
